<template>
  <form>
    <b-row>
      <b-col>
        <b-form-group label="Id" label-for="id-input">
          <b-form-input
              id="id-input"
              type="number"
              v-model="formValues.id"
              v-validate="{ required: true }"
              :state="validateState('id-input')"
              aria-describedby="id-input-live-feedback"
              data-vv-name="id-input"
              data-vv-as="Id"
              :disabled="isEdit"
              required
          />
          <b-form-invalid-feedback id="id-input-live-feedback">{{
              veeErrors.first('id-input')
            }}
          </b-form-invalid-feedback>
          <small class="form-text text-muted">
            Numeric side bet id
          </small>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-form-group label="Side Bet Name" label-for="name-input">
          <b-form-input
              v-model="formValues.name"
              v-validate="{ required: true }"
              :state="validateState('name-input')"
              aria-describedby="name-input-live-feedback"
              data-vv-name="name-input"
              data-vv-as="Side Bet Name"
              required
          />
          <b-form-invalid-feedback id="name-input-live-feedback">{{
              veeErrors.first('name-input')
            }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-form-group label="Configuration" label-for="config-input">
          <v-jsoneditor
              ref="config-editor"
              v-model="formValues.config"
              :options="{ mode: 'code', enableSort: false, enableTransform: false }"
              :plus="false"
              height="280px"
              @error="onConfigEditorError"
              @input="onConfigEditorInput"
          />
          <small v-if="configError" class="text-danger">{{ configError }}</small>
          <small class="form-text text-muted">
            Allowed keys: key, enabled, order, min, max, calculator, side, payout. Leave {} to store no configuration.
          </small>
        </b-form-group>
      </b-col>
    </b-row>
  </form>
</template>

<script>
import VJsoneditor from "v-jsoneditor/src/index";

const CONFIG_TEMPLATE = {
  key: '',
  enabled: true,
  order: 0,
  min: 0,
  max: 0,
  calculator: '',
  side: '',
  payout: ''
}

const ALLOWED_CONFIG_KEYS = Object.keys(CONFIG_TEMPLATE)

export default {
  components: {
    VJsoneditor
  },
  data() {
    return {
      isEdit: false,
      configError: null,
      formValues: this.getInitialValues()
    }
  },
  methods: {
    getInitialValues() {
      return {
        id: null,
        name: '',
        config: {...CONFIG_TEMPLATE}
      }
    },
    setData(data) {
      this.isEdit = data.id !== undefined && data.id !== null
      this.configError = null
      this.formValues = {
        id: data.id ?? null,
        name: data.name ?? '',
        config: data.config
            ? JSON.parse(JSON.stringify(data.config))
            : (this.isEdit ? {} : {...CONFIG_TEMPLATE})
      }
      this.$nextTick(() => {
        if (this.$validator) {
          this.$validator.reset()
        }
      })
    },
    onConfigEditorError() {
      this.configError = 'Invalid JSON'
    },
    onConfigEditorInput() {
      this.configError = null
    },
    validateConfig() {
      const config = this.formValues.config

      if (config === null || config === undefined) {
        return {ok: true, config: null}
      }

      if (Array.isArray(config) || typeof config !== 'object') {
        return {ok: false, error: 'Config must be a JSON object'}
      }

      if (Object.keys(config).length === 0) {
        return {ok: true, config: null}
      }

      const unknown = Object.keys(config).filter(key => !ALLOWED_CONFIG_KEYS.includes(key))
      if (unknown.length) {
        return {ok: false, error: 'Unknown keys: ' + unknown.join(', ')}
      }

      for (const key of ['order', 'min', 'max']) {
        if (config[key] !== undefined && config[key] !== null && typeof config[key] !== 'number') {
          return {ok: false, error: '"' + key + '" must be a number'}
        }
      }

      if (config.enabled !== undefined && typeof config.enabled !== 'boolean') {
        return {ok: false, error: '"enabled" must be true or false'}
      }

      if (typeof config.min === 'number' && typeof config.max === 'number' && config.min > config.max) {
        return {ok: false, error: '"min" must not be greater than "max"'}
      }

      return {ok: true, config: config}
    },
    getData() {
      const {config} = this.validateConfig()

      return {
        id: this.formValues.id,
        name: this.formValues.name,
        config: config ?? null
      }
    },
    isValid() {
      return this.$validator.validateAll().then(result => {
        if (this.configError) {
          return false
        }

        const validated = this.validateConfig()
        this.configError = validated.ok ? null : validated.error

        return result && validated.ok
      })
    },
    validateState(ref) {
      if (
          this.veeFields[ref] &&
          (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref)
      }
      return null
    }
  }
}
</script>
